import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import {
  trans,
  doubleNumber,
  groupByKey,
  setComoAfterThirdSymbol,
} from "../../../helpers/index";
import { localStorageGetItem } from "../../../storage/index";
import Select from "react-select";
import DatePicker from "react-datepicker";
import ApiManager from "../../../apiManager/index";
import Circle from "../../Fragments/Circle";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import Modal from "../../Fragments/Modal";
import Tab from "../../Fragments/Tab";
import ErrorModal from "../../Fragments/ErrorModal";
import Loading from "../../Fragments/Loading";
// TODO: Remove this import in production
import {
  mockFiltersData,
  mockExpensesData,
  mockTopupsData,
  mockRedemptionHistoryData,
  mockBalanceHistoryData,
  simulateApiDelay,
} from "./mockData";

const History = (props) => {
  const componentIsMounted = useRef(true);
  const startDateRef = useRef(new Date());

  const getOptions = useCallback(() => {
    return [
      {
        value: 1,
        label: trans(props.trans, "history.filter.select_option_text1"),
      },
      {
        value: 6,
        label: trans(props.trans, "history.filter.select_option_text2"),
      },
      {
        value: 13,
        label: trans(props.trans, "history.filter.select_option_text3"),
      },
      {
        value: "custom",
        label: trans(props.trans, "history.filter.select_option_other"),
      },
    ];
  }, [props.trans]);

  const [selectedOption, setSelectedOption] = useState(() => {
    const opts = [
      {
        value: 1,
        label: trans(props.trans, "history.filter.select_option_text1"),
      },
      {
        value: 6,
        label: trans(props.trans, "history.filter.select_option_text2"),
      },
      {
        value: 13,
        label: trans(props.trans, "history.filter.select_option_text3"),
      },
      {
        value: "custom",
        label: trans(props.trans, "history.filter.select_option_other"),
      },
    ];
    return opts[0];
  });
  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    return date;
  });
  const [endDate, setEndDate] = useState(new Date());
  const [filters, setFilters] = useState("");
  const [filtersGroup, setFiltersGroup] = useState("");
  const [onlyPaid, setOnlyPaid] = useState(false);
  const [expenses, setExpenses] = useState("");
  const [topups, setTopups] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [fileType, setFileType] = useState("pdf");
  const [modalButtonDisabled, setModalButtonDisabled] = useState(false);
  const [modalResponseData, setModalResponseData] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [allowedScrollAddNumber] = useState(10);
  const [allowedScrollNumber, setAllowedScrollNumber] = useState(0);
  const [allowedTopupsScrollNumber, setAllowedTopupsScrollNumber] = useState(0);
  const [allowedBonusScrollNumber, setAllowedBonusScrollNumber] = useState(0);
  const [allowedBonusStockPointsScrollNumber, setAllowedBonusStockPointsScrollNumber] = useState(0);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [redemptionHistory, setRedemptionHistory] = useState("");
  const [balanceHistory, setBalanceHistory] = useState("");
  const [isMockData, setIsMockData] = useState(false);
  const [dynamicGroupStates, setDynamicGroupStates] = useState({});

  useEffect(() => {
    if (props.parentState.switchAccount) {
      setFilters("");
      setFiltersGroup("");
      setExpenses("");
      setTopups("");
      setBalanceHistory("");
    }
  }, [props.parentState.switchAccount]);

  useEffect(() => {
    return () => {
      componentIsMounted.current = false;
    };
  }, []);

  const filterSuccess = useCallback((resolve) => {
    if (!componentIsMounted.current) {
      return false;
    }

    let filtersGroupObj = {};

    if (resolve.data.status === "OK") {
      resolve.data.data.filters.map((item) => {
        filtersGroupObj[item.value] = true;
        return true;
      });
    }

    setFilters(resolve.data);
    setFiltersGroup(filtersGroupObj);
  }, []);

  const errorCallBack = useCallback((reject) => {
    setShowErrorModal(true);
  }, []);

  const initAsyncCalls = useCallback(() => {
    if (isMockData) {
      simulateApiDelay(mockFiltersData, 500).then(filterSuccess, errorCallBack);
    } else {
      ApiManager.getRequest(
        {
          jwt: props.getDecryptedToken(),
        },
        "/detalization/config"
      ).then(filterSuccess, errorCallBack);
    }
  }, [isMockData, props, filterSuccess, errorCallBack]);

  useEffect(() => {
    initAsyncCalls();
  }, [initAsyncCalls]);

  useEffect(() => {
    if (props.parentState.switchAccount) {
      initAsyncCalls();
    }
  }, [props.parentState.switchAccount, initAsyncCalls]);

  const [mockDataChanged, setMockDataChanged] = useState(false);
  useEffect(() => {
    if (mockDataChanged) {
      initAsyncCalls();
      setMockDataChanged(false);
    }
  }, [mockDataChanged, initAsyncCalls]);

  const handleSelectChange = useCallback((newState) => {
    setSelectedOption(newState);
  }, []);

  const checkBySeconds = useCallback((d) => {
    return Math.floor(d.getTime() / 1000);
  }, []);

  const datepickerChangeHandler = useCallback(() => {
    const days = Math.floor((endDate - startDate) / 1000 / 60 / 60 / 24);

    if (days > 13) {
      setShowModal(true);
    }
  }, [endDate, startDate]);

  const datepickers = useMemo(() => {
    if (
      !selectedOption ||
      (selectedOption && selectedOption.value !== "custom")
    ) {
      return "";
    }
    let minDate, maxDate;
    if (filters?.data?.min_from_date) {
      minDate = new Date(filters?.data?.min_from_date);
      maxDate = new Date(filters?.data?.min_from_date);
      maxDate.setMonth(maxDate.getMonth() + 1);
    }

    return (
      <div className="history-form__pickers">
        <div className="history-form__pickers-item ver-top-box pr sprite-a">
          <DatePicker
            selected={startDate}
            minDate={minDate}
            maxDate={maxDate}
            dateFormat="dd-MM-yyyy"
            onChange={(date) => {
              let newStartDate = "";
              let newEndDate = endDate;

              if (date !== null) {
                const newDate = new Date(date);
                newStartDate = date;

                if (newEndDate) {
                  newEndDate =
                    checkBySeconds(date) > checkBySeconds(endDate)
                      ? new Date(newDate.setDate(newDate.getDate()))
                      : endDate;
                }
              }

              setStartDate(newStartDate);
              setEndDate(newEndDate);
              // Call handler after state update
              setTimeout(() => {
                const days = Math.floor((newEndDate - newStartDate) / 1000 / 60 / 60 / 24);
                if (days > 13) {
                  setShowModal(true);
                }
              }, 0);
            }}
          />
        </div>
        <div className="history-form__pickers-item ver-top-box pr sprite-a">
          <DatePicker
            selected={endDate}
            minDate={minDate}
            maxDate={maxDate}
            dateFormat="dd-MM-yyyy"
            onChange={(date) => {
              let newStartDate = startDate;
              let newEndDate = "";

              if (date !== null) {
                const newDate = new Date(date);
                newEndDate = date;

                if (newStartDate) {
                  newStartDate =
                    checkBySeconds(date) < checkBySeconds(startDate)
                      ? new Date(newDate.setDate(newDate.getDate()))
                      : startDate;
                }
              }

              setStartDate(newStartDate);
              setEndDate(newEndDate);
              // Call handler after state update
              setTimeout(() => {
                const days = Math.floor((newEndDate - newStartDate) / 1000 / 60 / 60 / 24);
                if (days > 13) {
                  setShowModal(true);
                }
              }, 0);
            }}
          />
        </div>
      </div>
    );
  }, [selectedOption, startDate, endDate, checkBySeconds]);

  const drawFilters = useMemo(() => {
    let filtersContent = <Loading withBox={true} />;

    if (filters !== "" && filters.status === "OK") {
      filtersContent = filters.data.filters.map((item, index) => {
        return (
          <div className="ver-top-box" key={index}>
            <input
              className="history-form__checkbox dn"
              name={`tag-${index}`}
              id={`tag-${index}`}
              type="checkbox"
              checked={filtersGroup[item.value]}
              onChange={() => {
                let newState = { ...filtersGroup };
                newState[item.value] = !newState[item.value];
                setFiltersGroup(newState);
              }}
            />
            <label
              className="history-form__tag ver-top-box fs14 pr"
              htmlFor={`tag-${index}`}
              style={{
                backgroundColor: item.color,
                borderColor: item.color,
              }}
            >
              <span
                className="history-form__tag-circle db center-center"
                style={{ backgroundColor: item.color }}
              >
                {" "}
              </span>
              {item.label}
            </label>
          </div>
        );
      });
    }

    if (filters !== "" && filters.status === "ERROR") {
      filtersContent = <p className="error-message">{filters.message}</p>;
    }

    return <div className="history-form__tag-list select-none">{filtersContent}</div>;
  }, [filters, filtersGroup]);

  const getDetalizationExpensesSuccess = useCallback((resolve) => {
    setExpenses(resolve.data);
    setButtonDisabled(false);
  }, []);

  const getDetalizationTopupsSuccess = useCallback((resolve) => {
    setTopups(resolve.data);
  }, []);

  const redemptionHistorySuccess = useCallback((resolve) => {
    setRedemptionHistory(resolve.data);
  }, []);

  const balanceHistorySuccess = useCallback((resolve) => {
    if (!componentIsMounted.current) {
      return;
    }
    setBalanceHistory(resolve.data);
  }, []);

  const getFilteredData = useCallback((event) => {
    event.preventDefault();
    setButtonDisabled(true);
    setExpenses("");
    setTopups("");
    setRedemptionHistory("");
    setBalanceHistory("");
    setAllowedScrollNumber(20);
    setAllowedTopupsScrollNumber(10);
    setAllowedBonusScrollNumber(10);
    setAllowedBonusStockPointsScrollNumber(10);

    let fromDateValue = startDate;
    let toDateValue = endDate;

    if (selectedOption && selectedOption.value !== "custom") {
      let d = new Date();
      toDateValue = new Date();
      fromDateValue = new Date(d.setDate(d.getDate() - selectedOption.value));
    }

    let fromDateStr = "";
    let toDateStr = "";

    if (fromDateValue) {
      fromDateStr =
        fromDateValue.getFullYear() +
        "-" +
        doubleNumber(fromDateValue.getMonth() + 1) +
        "-" +
        doubleNumber(fromDateValue.getDate());
    }

    if (toDateValue) {
      toDateStr =
        toDateValue.getFullYear() +
        "-" +
        doubleNumber(toDateValue.getMonth() + 1) +
        "-" +
        doubleNumber(toDateValue.getDate());
    }

    let sendData = {
        jwt: props.getDecryptedToken(),
        from_date: fromDateStr,
        to_date: toDateStr,
        format: "json",
      },
      filtersGroupCounter = 0;

    for (let i in filtersGroup) {
      if (filtersGroup[i]) {
        sendData["f[" + filtersGroupCounter++ + "]"] = i;
      }
    }

    if (isMockData) {
      // Use mock data
      simulateApiDelay(mockExpensesData, 800).then(
        getDetalizationExpensesSuccess,
        errorCallBack
      );

      simulateApiDelay(mockTopupsData, 600).then(
        getDetalizationTopupsSuccess,
        errorCallBack
      );
    } else {
      // Get expenses list
      ApiManager.getRequest(sendData, "/detalization/expenses").then(
        getDetalizationExpensesSuccess,
        errorCallBack
      );

      // Get topups list
      // ApiManager.getRequest(sendData, "/detalization/topups").then(
      //   getDetalizationTopupsSuccess,
      //   errorCallBack
      // );
    }

    if (isMockData) {
      // Use mock data
      simulateApiDelay(mockRedemptionHistoryData, 700).then(
        redemptionHistorySuccess,
        errorCallBack
      );

      simulateApiDelay(mockBalanceHistoryData, 900).then(
        balanceHistorySuccess,
        errorCallBack
      );
    } else {
      // Get available category items
      ApiManager.postRequest(
        {
          _token: props.csrf_token.data,
          jwt: props.getDecryptedToken(),
          source: "WEB",
          channel: "EXTERNAL",
          externalReferenceId: 1,
          subscriberId: props.parentState.accountData.data.number.replace(
            /\s|^\+3/g,
            ""
          ),
          subscriberIdType: "Msisdn",
          language: localStorageGetItem("defaultLngPrefix").toUpperCase(),
          walletType: "WALLET_DEFAULT",
          startDate: fromDateStr,
          endDate: toDateStr,
        },
        "/bls/redemption-history"
      ).then(redemptionHistorySuccess, errorCallBack);

      // Get query stock points
      ApiManager.postRequest(
        {
          _token: props.csrf_token.data,
          jwt: props.getDecryptedToken(),
          subscriberId: props.parentState.accountData.data.number.replace(
            /\s|^\+3/g,
            ""
          ),
        },
        "/bls/balance-history"
      ).then(balanceHistorySuccess, errorCallBack);
    }
  }, [
    startDate,
    endDate,
    selectedOption,
    filtersGroup,
    isMockData,
    props,
    getDetalizationExpensesSuccess,
    getDetalizationTopupsSuccess,
    redemptionHistorySuccess,
    balanceHistorySuccess,
    errorCallBack,
  ]);

  const scrollHandler = useCallback((event, count, stateName) => {
    if (
      event.target.scrollTop + event.target.offsetHeight >
        event.target.scrollHeight - 50
    ) {
      if (stateName === "allowedScrollNumber" && count > allowedScrollNumber) {
        setAllowedScrollNumber(allowedScrollNumber + allowedScrollAddNumber);
      } else if (stateName === "allowedTopupsScrollNumber" && count > allowedTopupsScrollNumber) {
        setAllowedTopupsScrollNumber(allowedTopupsScrollNumber + allowedScrollAddNumber);
      } else if (stateName === "allowedBonusScrollNumber" && count > allowedBonusScrollNumber) {
        setAllowedBonusScrollNumber(allowedBonusScrollNumber + allowedScrollAddNumber);
      } else if (stateName === "allowedBonusStockPointsScrollNumber" && count > allowedBonusStockPointsScrollNumber) {
        setAllowedBonusStockPointsScrollNumber(allowedBonusStockPointsScrollNumber + allowedScrollAddNumber);
      }
    }
  }, [allowedScrollNumber, allowedTopupsScrollNumber, allowedBonusScrollNumber, allowedBonusStockPointsScrollNumber, allowedScrollAddNumber]);

  const filterSection = useMemo(() => {
    return (
      <section className="main-wrapper__services main-wrapper__services--with-space">
        <div className="main-wrapper__services-title-box pr">
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--filter monserrat-medium tl pr sprite-b trans-background">
            {trans(props.trans, "history.filter.title")}
          </h2>
          {/* TODO: Remove this mock data toggle in production */}
          {/* <div style={{ position: 'absolute', right: '10px', top: '10px', display: 'flex', alignItems: 'center', fontSize: '12px', color: '#666' }}>
            <span style={{ marginRight: '8px' }}>Mock Data</span>
            <input
              type="checkbox"
              checked={isMockData}
              onChange={() => {
                setIsMockData(!isMockData);
                // Reset data when switching modes
                setFilters("");
                setFiltersGroup("");
                setExpenses("");
                setTopups("");
                setRedemptionHistory("");
                setBalanceHistory("");
                // Reinitialize data after state change
                setTimeout(() => {
                  if (!isMockData) {
                    initAsyncCalls();
                  }
                }, 0);
              }}
              style={{ marginRight: '8px' }}
            />
            <span>{isMockData ? 'ON' : 'OFF'}</span>
          </div> */}
        </div>

        <form
          className="history-form"
          method="post"
          action="#"
          onSubmit={getFilteredData}
        >
          <div className="history-form__flex">
            <div className="history-form__item">
              <div className="history-form__label-box">
                <label className="history-form__label fs11" htmlFor="select">
                  {trans(props.trans, "history.filter.select_label")}
                </label>
              </div>

              <div className="history-form__select-box">
                <Select
                  options={getOptions()}
                  value={selectedOption}
                  onChange={handleSelectChange}
                  placeholder={trans(
                    props.trans,
                    "history.filter.select_default_label"
                  )}
                  noOptionsMessage={() =>
                    trans(
                      props.trans,
                      "history.filter.select_no_options_message"
                    )
                  }
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999
                    }),
                    menuPortal: (provided) => ({
                      ...provided,
                      zIndex: 9999
                    })
                  }}
                />
              </div>

              {datepickers}
            </div>

            <div className="history-form__item">
              <div className="history-form__label-box">
                <label className="history-form__label fs11" htmlFor="tag">
                  {trans(props.trans, "history.filter.tag_label")}
                </label>
              </div>
              {drawFilters}
            </div>

            <div className="history-form__item history-form__item--top-space">
              <button
                className={`btn btn--white no-wrap fs17 full-width${
                  buttonDisabled ? " btn--loading" : ""
                }`}
                type="submit"
                disabled={buttonDisabled}
              >
                {trans(props.trans, "history.filter.button_text2")}
              </button>
            </div>
          </div>
        </form>
      </section>
    );
  }, [props.trans, isMockData, selectedOption, startDate, endDate, filters, filtersGroup, onlyPaid, buttonDisabled, getOptions, handleSelectChange, datepickers, drawFilters, getFilteredData, initAsyncCalls]);

  const expensesFiltersList = useMemo(() => {
    let result = (
      <div className="main-wrapper__progress-box">
        <ul className="progress-list">
          <li className="progress-list__item progress-list__item--full">
            {trans(props.trans, "history.graphics.empty_message")}
          </li>
        </ul>
      </div>
    );

    if (
      expenses !== "" &&
      expenses.status === "OK" &&
      expenses.data.records.length
    ) {
      let grouping = groupByKey(expenses.data.records, "group_type"),
        groupedPrice = {},
        totalCount = 0,
        groupedItems = Object.keys(grouping);

      groupedItems.map((item) => {
        if (!groupedPrice.hasOwnProperty(item)) {
          groupedPrice[item] = {
            count: 0,
            label: "",
            color: "",
            currency: "",
          };
        }

        grouping[item].map((groupItem) => {
          groupedPrice[item]["count"] += Number(groupItem["price"]);

          if (groupedPrice[item]["label"] === "") {
            groupedPrice[item]["label"] = groupItem["group_label"];
          }

          if (groupedPrice[item]["color"] === "") {
            groupedPrice[item]["color"] = groupItem["color"];
          }

          if (groupedPrice[item]["currency"] === "") {
            groupedPrice[item]["currency"] = groupItem["currency"];
          }

          return groupedPrice;
        });

        return (totalCount += groupedPrice[item]["count"]);
      });

      const progressItems = Object.keys(groupedPrice).map((item, index) => {
        let groupItem = groupedPrice[item];

        return (
          <li className="progress-list__item ver-top-box" key={index}>
            <div className="progress-list__circle pr">
              <Circle
                params={{
                  start: 421,
                  height: 158,
                  width: 158,
                  cx: 79,
                  cy: 79,
                  radius: 67,
                  strokeWidth: 22,
                  fill: "transparent",
                  count: groupItem.count,
                  color: groupItem.color,
                  totalCount: totalCount,
                }}
              />
              <div
                className="progress-list__price fb fs20 pr"
                style={{
                  color: groupItem.color,
                }}
              >
                {setComoAfterThirdSymbol(Math.round(groupItem.count)) +
                  " " +
                  groupItem.currency}
              </div>
            </div>
            <h3
              className="progress-list__title fb tu"
              style={{
                color: groupItem.color,
              }}
            >
              {groupItem.label}
            </h3>
          </li>
        );
      });

      result = (
        <div className="main-wrapper__progress-box">
          <ul className="progress-list tc">{progressItems}</ul>
        </div>
      );
    }

    if (buttonDisabled) {
      result = <Loading withBox={true} />;
    }

    if (expenses !== "" && expenses.status === "ERROR") {
      result = <p className="error-message">{expenses.message}</p>;
    }

    return (
      <section className="main-wrapper__services main-wrapper__services--with-space">
        <div className="main-wrapper__services-title-box pr">
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--graphics monserrat-medium tl pr sprite-b trans-background">
            {trans(props.trans, "history.graphics.title")}
          </h2>
        </div>
        {result}
      </section>
    );
  }, [expenses, buttonDisabled, props.trans]);

  const topupsList = useMemo(() => {
    let result = (
        <div className="main-wrapper__list-out">
          <ul className="list list--inclusions">
            <li className="list__item">
              <div className="list__link">
                <div className="list__inner-info--dark">
                  {trans(props.trans, "history.topups.empty_message")}
                </div>
              </div>
            </li>
          </ul>
        </div>
      ),
      radiusClass = "",
      sum = "";

    if (
      topups !== "" &&
      topups.status === "OK" &&
      topups.data.records.length
    ) {
      let grouping = groupByKey(topups.data.records, "date"),
        groupedPrice = {},
        totalCount = 0,
        groupedItems = Object.keys(grouping),
        historyIndex = 1;

      groupedItems
        .sort((a, b) => new Date(b) - new Date(a))
        .map((item) => {
          if (!groupedPrice.hasOwnProperty(item)) {
            groupedPrice[item] = {
              price: 0,
              currency: "",
            };
          }

          grouping[item].map((groupItem) => {
            groupedPrice[item]["price"] += Number(groupItem["price"]);

            if (groupedPrice[item]["currency"] === "") {
              groupedPrice[item]["currency"] = groupItem["currency"];
            }

            return groupedPrice;
          });
          return (totalCount += groupedPrice[item]["price"]);
        });

      const progressItems = Object.keys(groupedPrice).map((item, index) => {
        if (allowedTopupsScrollNumber < historyIndex) {
          return "";
        }

        historyIndex++;

        let groupItem = groupedPrice[item];

        return (
          <li className="list__item" key={index}>
            <div className="list__link pr clear-fix">
              <div className="list__inner-info ver-top-box tl">{item}</div>
              <div className="list__inner-info fb ver-top-box tr">
                {setComoAfterThirdSymbol(Math.round(groupItem.price))}{" "}
                {groupItem.currency}
              </div>
            </div>
          </li>
        );
      });

      result = (
        <div
          className="main-wrapper__list-out main-wrapper__list-out--small scroller-block"
          onScroll={(event) =>
            scrollHandler(event, historyIndex, "allowedTopupsScrollNumber")
          }
        >
          <ul className="list list--inclusions">{progressItems}</ul>
        </div>
      );

      sum = (
        <div className="main-wrapper__total-box tc">
          <span className="main-wrapper__total-title ver-top-box">
            {trans(props.trans, "history.topups.sum_label")}
          </span>
          <strong className="main-wrapper__total-sum fs20 ver-top-box">
            {setComoAfterThirdSymbol(
              Math.round(topups.data.topups_sum)
            )}{" "}
            {topups.data.topups_sum_currency}
          </strong>
        </div>
      );

      radiusClass = " main-wrapper__services--none-bottom-radius";
    }

    if (buttonDisabled) {
      result = <Loading withBox={true} />;
    }

    if (topups !== "" && topups.status === "ERROR") {
      result = <p className="error-message">{topups.message}</p>;
    }

    return (
      <div className="main-wrapper__double-list-item ver-top-box">
        <section className={`main-wrapper__services${radiusClass}`}>
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--plus monserrat-medium pr sprite-b">
            {trans(props.trans, "history.apps.title")}
          </h2>
          {result}
        </section>
        {sum}
      </div>
    );
  }, [topups, buttonDisabled, allowedTopupsScrollNumber, scrollHandler, props.trans]);

  const expensesList = useMemo(() => {
    let result = (
        <div className="main-wrapper__list-out main-wrapper__list-out--services-big">
          <div className="list list--inclusions">
            <div className="list__item">
              <div className="list__link">
                <div className="list__inner-info--dark">
                  {trans(props.trans, "history.expenses.empty_message")}
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
      radiusClass = "",
      sum = "";

    if (
      expenses !== "" &&
      expenses.status === "OK" &&
      expenses.data.records.length
    ) {
      let grouping = groupByKey(expenses.data.records, "date"),
        groupedItems = Object.keys(grouping),
        historyIndex = 1;

      const groupList = groupedItems
        .sort(
          (a, b) =>
            new Date(a.split(".").reverse().join(" ")) -
            new Date(b.split(".").reverse().join(" "))
        )
        .map((item, index) => {
          if (allowedScrollNumber < historyIndex) {
            return "";
          }

          let innerGrouping = groupByKey(grouping[item], "group_type"),
            innerGroupedItems = Object.keys(innerGrouping);

          const progressItems = innerGroupedItems.map((item1) => {
            let groupedPrice = {},
              groupBox = "",
              stateKey = "historyGroupItem" + historyIndex++;

            // Group getter
            if (dynamicGroupStates.hasOwnProperty(stateKey) && dynamicGroupStates[stateKey]) {
              groupBox = innerGrouping[item1]
                .sort(
                  (a, b) =>
                    new Date(a.date + " " + a.time) -
                    new Date(b.date + " " + b.time)
                )
                .map((item2, index2) => {
                  return (
                    <div className="list__item" key={index2}>
                      <div className="list__link pr">
                        <div className="list__services-first">
                          <div className="list__inner-info list__inner-info--dark fb">
                            {item2.number}{" "}
                          </div>
                          <p className="list__inner-info fs14">{item2.time}</p>
                          <p className="list__inner-info fs14"><strong>{item2.direction}</strong></p>
                        </div>

                        <div className="list__services-second tr">
                          <div className="list__inner-info--dark fb">
                            {item2.price} {item2.currency}
                          </div>
                          <p className="list__inner-time fs14">
                            {item2.traffic}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                });

              groupBox = <div className="list__group">{groupBox}</div>;
            }

            // Button getter
            if (!groupedPrice.hasOwnProperty(item1)) {
              groupedPrice[item1] = {
                price: 0,
                label: "",
                color: "",
                currency: "",
              };
            }

            innerGrouping[item1].map((groupItem) => {
              groupedPrice[item1]["price"] += Number(groupItem["price"]);
                groupedPrice[item1]["label"] = groupItem["group_label"];
                

              if (groupedPrice[item1]["color"] === "") {
                groupedPrice[item1]["color"] = groupItem["color"];
              }

              if (groupedPrice[item1]["currency"] === "") {
                groupedPrice[item1]["currency"] = groupItem["currency"];
              }

              return true;
            });
            return Object.keys(groupedPrice).map((item3, stateIndex) => {
              let groupItem = groupedPrice[item3],
                groupState = dynamicGroupStates.hasOwnProperty(stateKey) && dynamicGroupStates[stateKey];

              historyIndex++;

              if (onlyPaid && groupItem.price === 0) {
                return "";
              }
              return (
                <div key={stateIndex}>
                  <button
                    className={`list__item list__item--group full-width tl${
                      groupState ? " list__item--group-active" : ""
                    }`}
                    type="button"
                    style={{ backgroundColor: groupItem.color }}
                    onClick={() => {
                      setDynamicGroupStates(prev => ({
                        ...prev,
                        [stateKey]: !groupState
                      }));
                    }}
                  >
                    <span className="list__link db pr sprite-a list__link--white-bg">
                      <span
                        className="list__circle db center-center"
                        style={{ backgroundColor: groupItem.color }}
                      >
                        {" "}
                      </span>
                      <span className="list__services-first db">
                        <span className="list__inner-info list__inner-info--dark db">
                          {groupItem.label}
                        </span>
                      </span>
                      <span className="list__services-second db tr">
                        <span className="list__inner-info--dark db fb">
                          {setComoAfterThirdSymbol(Math.round(groupItem.price))}{" "}
                          {groupItem.currency}
                        </span>
                      </span>
                    </span>
                  </button>
                  {groupBox}
                </div>
              );
            });
          });

          return (
            <div key={index}>
              <div className="list__item list__item--title monserrat-medium">
                {item}
              </div>
              {progressItems}
            </div>
          );
        });

      result = (
        <div
          className="main-wrapper__list-out main-wrapper__list-out--services-big scroller-block"
          onScroll={(event) =>
            scrollHandler(event, historyIndex, "allowedScrollNumber")
          }
        >
          <div className="list list--double list--inner mb-none">
            {groupList}
          </div>
        </div>
      );

      sum = (
        <div className="main-wrapper__total-box tc">
          <span className="main-wrapper__total-title ver-top-box">
            {trans(props.trans, "history.expenses.sum_label")}
          </span>
          <strong className="main-wrapper__total-sum fs20 ver-top-box">
            {setComoAfterThirdSymbol(
              Math.round(expenses.data.expenses_sum)
            )}{" "}
            {expenses.data.expenses_sum_currency}
          </strong>
        </div>
      );

      radiusClass =
        " main-wrapper__services--details main-wrapper__services--none-bottom-radius";
    }

    if (buttonDisabled) {
      result = <Loading withBox={true} />;
    }

    if (expenses !== "" && expenses.status === "ERROR") {
      result = <p className="error-message">{expenses.message}</p>;
    }

    return (
      <>
        <section className={`main-wrapper__services${radiusClass}`}>
          <h2 className="main-wrapper__sub-title main-wrapper__sub-title--history monserrat-medium pr sprite-b">
            {trans(props.trans, "history.deciphering.title")}
          </h2>
          {result}
        </section>
        {sum}
      </>
    );
  }, [expenses, buttonDisabled, allowedScrollNumber, onlyPaid, dynamicGroupStates, scrollHandler, props.trans]);

  const resetDatepickers = useCallback(() => {
    setShowModal(false);
    setModalButtonDisabled(false);
  }, []);

  const sendEmailExpensesDataSuccess = useCallback((resolve) => {
    setModalButtonDisabled(false);
    setModalResponseData(resolve.data);

    if (resolve.data.status === "OK") {
      resetDatepickers();
      setShowSuccessModal(true);
    }
  }, [resetDatepickers]);

  const sendReportToEmail = useCallback((event) => {
    event.preventDefault();
    setModalButtonDisabled(true);

    let fromDateValue = startDate;
    let toDateValue = endDate;

    let fromDateStr = "";
    let toDateStr = "";

    if (fromDateValue) {
      fromDateStr =
        fromDateValue.getFullYear() +
        "-" +
        doubleNumber(fromDateValue.getMonth() + 1) +
        "-" +
        doubleNumber(fromDateValue.getDate());
    }

    if (toDateValue) {
      toDateStr =
        toDateValue.getFullYear() +
        "-" +
        doubleNumber(toDateValue.getMonth() + 1) +
        "-" +
        doubleNumber(toDateValue.getDate());
    }

    // Send email report file
    ApiManager.getRequest(
      {
        jwt: props.getDecryptedToken(),
        from_date: fromDateStr,
        to_date: toDateStr,
        email: email,
        format: fileType,
      },
      "/detalization/expenses"
    ).then(sendEmailExpensesDataSuccess, errorCallBack);
  }, [startDate, endDate, email, fileType, props, sendEmailExpensesDataSuccess, errorCallBack]);

  const emailModal = useMemo(() => {
    if (!showModal) {
      return "";
    }

    let errorEmailClass = "";
    let errorEmailBox = "";
    let errorBox = "";

    if (modalResponseData !== "") {
      if (modalResponseData.status === "INVALID_DATA") {
        if (modalResponseData.errors.hasOwnProperty("email")) {
          errorEmailClass = " form-error";
          errorEmailBox = (
            <div className="form-error-text fs11">
              {modalResponseData.errors.email}
            </div>
          );
        }

        if (modalResponseData.errors.hasOwnProperty("token")) {
          errorBox = (
            <FormMiddlewareError
              message={modalResponseData.errors.token}
            />
          );
        }
      }

      if (modalResponseData.status === "ERROR") {
        errorBox = (
          <FormMiddlewareError message={modalResponseData.message} />
        );
      }
    }

    return (
      <div className="modal modal--full fade show scroller-block">
        <div className="modal__content modal-dialog pr">
          <div className="table">
            <div className="table-cell">
              <div className="modal__inner pr">
                <h3 className="modal__title monserrat-medium fs30 tc">
                  {trans(props.trans, "history.modal.title")}
                </h3>

                <p className="modal__description fs13 tc">
                  {trans(props.trans, "history.modal.description")}
                </p>

                <form
                  action="#"
                  method="post"
                  onSubmit={sendReportToEmail}
                >
                  <div className={`form__form-box${errorEmailClass}`}>
                    <label className="form__label db fs11" htmlFor="email">
                      {trans(props.trans, "history.modal.email_label")}
                    </label>
                    <div className="form__field-out pr">
                      <input
                        className="form__field fs13"
                        id="email"
                        type="text"
                        name="email"
                        value={email}
                        onChange={(event) =>
                          setEmail(event.target.value.trim())
                        }
                      />
                    </div>
                    {errorEmailBox}
                  </div>

                  <div className="form__form-box">
                    <label className="form__label db fs11" htmlFor="email">
                      {trans(props.trans, "history.modal.file_label")}
                    </label>
                    <div className="form__radio-group">
                      <input
                        className="form__radio dn"
                        name="type-radio"
                        type="radio"
                        id="type-1"
                        checked={fileType === "pdf"}
                        onChange={() => setFileType("pdf")}
                      />
                      <label
                        className="form__radio-label fs12 ver-top-box pr"
                        htmlFor="type-1"
                      >
                        {trans(
                          props.trans,
                          "history.modal.file_pdf_label"
                        )}
                      </label>
                      <input
                        className="form__radio dn"
                        name="type-radio"
                        type="radio"
                        id="type-2"
                        checked={fileType === "excel"}
                        onChange={() => setFileType("excel")}
                      />
                      <label
                        className="form__radio-label fs12 ver-top-box pr"
                        htmlFor="type-2"
                      >
                        {trans(
                          props.trans,
                          "history.modal.file_excel_label"
                        )}
                      </label>
                    </div>
                  </div>

                  {errorBox}

                  <button
                    className={`modal__submit-btn btn btn--with-space btn--yellow${
                      modalButtonDisabled ? " btn--loading" : ""
                    }`}
                    type="submit"
                    disabled={modalButtonDisabled}
                  >
                    {trans(props.trans, "history.modal.send_title")}
                  </button>

                  <button
                    className="modal__cancel-btn btn btn--white"
                    type="button"
                    onClick={resetDatepickers}
                  >
                    {trans(props.trans, "history.modal.cancel_title")}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }, [showModal, modalResponseData, email, fileType, modalButtonDisabled, props.trans, sendReportToEmail, resetDatepickers]);

  const emailSuccessModal = useMemo(() => {
    if (!showSuccessModal) {
      return "";
    }

    return (
      <Modal
        title={trans(props.trans, "history.success_modal.title")}
        description={trans(
          props.trans,
          "history.success_modal.description"
        )}
        agreeText={trans(props.trans, "history.success_modal.agree")}
        agreeAction={() => setShowSuccessModal(false)}
        className="modal--full"
      />
    );
  }, [showSuccessModal, props.trans]);

  const errorModal = useMemo(() => {
    if (!showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(props.trans, "error.modal.title")}
        description={trans(props.trans, "error.modal.description")}
        action_text={trans(props.trans, "error.modal.action_text")}
      />
    );
  }, [showErrorModal, props.trans]);

  const expendedPoints = useMemo(() => {
    let listItems = (
        <div className="main-wrapper__list-out main-wrapper__list-out--medium scroller-block">
          <ul className="list list--double">
            <li className="list__item">
              <div className="list__link">
                <div className="list__inner-info--dark">
                  {trans(props.trans, "history.expended.empty_message")}
                </div>
              </div>
            </li>
          </ul>
        </div>
      ),
      detailsClass = "";

    if (
      redemptionHistory !== "" &&
      redemptionHistory.status === "OK"
    ) {
      if (
        redemptionHistory.data.hasOwnProperty("RedemptionLog") &&
        redemptionHistory.data.RedemptionLog.length
      ) {
        detailsClass =
          " main-wrapper__services--details main-wrapper__services--info";

        const groupedItems = {};

        redemptionHistory.data.RedemptionLog.map((item) => {
          const date = new Date(
            item.ItemsLogs.RedemptionItemsLog.CommandDateTime
          );
          const newDate =
            doubleNumber(date.getDate()) +
            "." +
            doubleNumber(date.getMonth() + 1) +
            "." +
            date.getFullYear().toString().substr(-2);
          const time =
            doubleNumber(date.getHours()) +
            ":" +
            doubleNumber(date.getMinutes());
          const data = {
            name: item.ItemsLogs.RedemptionItemsLog.RedeemableItem.Name,
            point: item.ItemsLogs.RedemptionItemsLog.PricePointsPerUnit,
            time: time,
            date,
          };

          return groupedItems.hasOwnProperty(newDate)
            ? groupedItems[newDate].push(data)
            : (groupedItems[newDate] = [data]);
        });

        let itemKey = 0;

        listItems = [];

        Object.keys(groupedItems)
          .sort()
          .map((item) => {
            if (allowedBonusScrollNumber < itemKey) {
              return listItems;
            }

            listItems.push(
              <li
                className="list__item list__item--title monserrat-medium"
                key={itemKey}
              >
                {item}
              </li>
            );

            groupedItems[item]
              .sort((a, b) => new Date(b.date) - new Date(a.date))
              .map((groupItem) => {
                itemKey++;

                return listItems.push(
                  <li className="list__item" key={itemKey}>
                    <div className="list__link list__link--space-24 pr">
                      <div className="list__services-first">
                        <div className="list__inner-info list__inner-info--dark fb">
                          {groupItem.name}
                        </div>
                        <p className="list__inner-info fs14">
                          {groupItem.time}
                        </p>
                      </div>
                      <div className="list__services-second">
                        <div className="list__inner-info--dark fb">
                          {groupItem.point}{" "}
                          {trans(props.trans, "bonus.tab.points_title")}
                        </div>
                      </div>
                    </div>
                  </li>
                );
              });

            itemKey++;

            return listItems;
          });

        listItems = (
          <div
            className="main-wrapper__list-out main-wrapper__list-out--medium scroller-block"
            onScroll={(event) =>
              scrollHandler(event, itemKey, "allowedBonusScrollNumber")
            }
          >
            <ul className="list list--double">{listItems}</ul>
          </div>
        );
      }
    }

    if (buttonDisabled) {
      listItems = <Loading withBox={true} />;
    }

    if (
      redemptionHistory !== "" &&
      redemptionHistory.status === "ERROR"
    ) {
      listItems = (
        <p className="error-message">{redemptionHistory.message}</p>
      );
    }

    return { detailsClass, listItems };
  }, [redemptionHistory, buttonDisabled, allowedBonusScrollNumber, scrollHandler, props.trans]);

  const accumulatedPoints = useMemo(() => {
    let listItems = (
      <div className="main-wrapper__list-out main-wrapper__list-out--medium">
        <ul className="list list--double list--accumulated">
          <li className="list__item">
            <div className="list__link">
              <div className="list__inner-info--dark">
                {trans(props.trans, "bonus.expended.empty_message")}
              </div>
            </div>
          </li>
        </ul>
      </div>
    );

    if (
      balanceHistory !== "" &&
      balanceHistory.status === "OK"
    ) {
      if (
        balanceHistory.data.hasOwnProperty("BalanceLog") &&
        balanceHistory.data.BalanceLog.length
      ) {
        const groupedItems = {};

        balanceHistory.data.BalanceLog.map((item) => {
          if (item.Points < 0) {
            return "";
          }

          const date = new Date(item.CommandDatetime);
          const newDate =
            doubleNumber(date.getDate()) +
            "." +
            doubleNumber(date.getMonth() + 1) +
            "." +
            date.getFullYear().toString().substr(-2);
          const time =
            doubleNumber(date.getHours()) +
            ":" +
            doubleNumber(date.getMinutes());
          const data = {
            point: item.Points,
            time: time,
            date,
          };

          return groupedItems.hasOwnProperty(newDate)
            ? groupedItems[newDate].push(data)
            : (groupedItems[newDate] = [data]);
        });

        let itemKey = 0;

        listItems = [];

        Object.keys(groupedItems)
          .sort()
          .map((item) => {
            if (allowedBonusStockPointsScrollNumber < itemKey) {
              return listItems;
            }

            listItems.push(
              <li
                className="list__item list__item--title monserrat-medium"
                key={itemKey}
              >
                {item}
              </li>
            );

            groupedItems[item]
              .sort((a, b) => new Date(b.date) - new Date(a.date))
              .map((groupItem) => {
                itemKey++;

                return listItems.push(
                  <li className="list__item" key={itemKey}>
                    <div className="list__link list__link--space-24 pr clear-fix">
                      <div className="list__inner-info list__inner-info--dark fb ver-top-box tl">
                        {groupItem.point}{" "}
                        {trans(props.trans, "bonus.expended.points_title")}
                      </div>
                      <div className="list__inner-info fs14 ver-top-box tr">
                        {groupItem.time}
                      </div>
                    </div>
                  </li>
                );
              });

            itemKey++;

            return listItems;
          });

        listItems = (
          <div
            className="main-wrapper__list-out main-wrapper__list-out--medium scroller-block"
            onScroll={(event) =>
              scrollHandler(
                event,
                itemKey,
                "allowedBonusStockPointsScrollNumber"
              )
            }
          >
            <ul className="list list--double list--accumulated">{listItems}</ul>
          </div>
        );
      }
    }

    if (buttonDisabled) {
      listItems = <Loading withBox={true} />;
    }

    if (
      balanceHistory !== "" &&
      balanceHistory.status === "ERROR"
    ) {
      listItems = (
        <p className="error-message">{balanceHistory.message}</p>
      );
    }

    return listItems;
  }, [balanceHistory, buttonDisabled, allowedBonusStockPointsScrollNumber, scrollHandler, props.trans]);

  // const bonusList = useMemo(() => {
  //   return (
  //     <div className="main-wrapper__double-list-item ver-top-box">
  //       <section
  //         className={`main-wrapper__services main-wrapper__services--bonus${
  //           expendedPoints["detailsClass"]
  //         }`}
  //       >
  //         <h2 className="main-wrapper__sub-title main-wrapper__sub-title--bonus monserrat-medium pr sprite-b">
  //           {trans(props.trans, "bonus.tab.title")}
  //         </h2>
  //         <Tab
  //           items={[
  //             {
  //               title: trans(props.trans, "bonus.tab.sub_title1"),
  //               content: accumulatedPoints,
  //             },
  //             {
  //               title: trans(props.trans, "bonus.tab.sub_title2"),
  //               content: expendedPoints["listItems"],
  //             },
  //           ]}
  //         />
  //       </section>
  //     </div>
  //   );
  // }, [expendedPoints, accumulatedPoints, props.trans]);

  return (
    <>
      {filterSection}
      <div className="main-wrapper__inner-left fl">{expensesList}</div>
      <div className="main-wrapper__inner-big">
        {expensesFiltersList}
        <div className="main-wrapper__double-list">
          {topupsList}
          {/* {bonusList} */}
        </div>
      </div>
      {emailModal}
      {emailSuccessModal}
      {errorModal}
    </>
  );
};

export default History;